import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Features.css";

const features = [
  {
    title: "Grader Demo",
    hoverText: "Grading Demo - Grade your answers and get instant feedback.",
    image: "/resources/Images/Question.jpg",
    link: "/grade-demo",
    status: "available",
  },
  {
    title: "Chat Demo",
    hoverText: "Chat Demo - Chat with our AI-powered chatbot.",
    image: "/resources/Images/Question.jpg",
    link: "/chat-demo",
    status: "available",
  },
  {
    title: "Write! Write! Write!",
    hoverText:
      "Writing is how one organizes thoughts for professional to personal development journey",
    image: "/resources/Images/Learning.jpg",
    link: "/write",
    status: "available",
  },
  {
    title: "Speak! Speak! Speak!",
    hoverText:
      "Social animal in a social world needs to speak up and practise professional to personal needs",
    image: "/resources/Images/Learning.jpg",
    link: "/virtual-assistant",
    status: "coming-soon",
  },
  

];

const Features = () => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const navigate = useNavigate();

  return (
    <section className="features-section">
      <h2 className="features-title">Your New Companions</h2>
      <div className="features-grid">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`feature-card ${feature.status === "coming-soon" ? "coming-soon" : ""}`}
            style={{ backgroundImage: `url(${feature.image})` }}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            onClick={() => feature.status === "available" && navigate(feature.link)}
          >
            <div className="feature-overlay">
              <h3>{hoverIndex === index ? feature.hoverText : feature.title}</h3>
            </div>
            <div className="status-text">
              {feature.status === "available" ? "Explore →" : "Coming Soon"}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
